var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value)?_c('v-chip',{staticClass:"cursor-pointer",class:_vm.getColor + '--text',attrs:{"color":_vm.getColor,"outlined":""}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }